import React from 'react';
import { Controller } from 'react-hook-form';
import LabeledSelectBox from '../../../../ui/select-box/labeled';
import SelectBox from '../../../../ui/select-box';
import { VALUE_TYPES } from '../../../../../constants/limits';

const LimitValueTypeSel = ({ control }) => {
  return (
    <section id='limitsValueType' className='flex flex-col gap-4'>
      <div>
      <Controller
          name='value_type'
          control={control}
          render={({ field: { value, name, onChange }, fieldState: { error } }) => (
            <LabeledSelectBox label={'Limit value type'} isRequired={true} error={error}>
              <SelectBox
                name={name}
                placeholder={'Select a limit value type'}
                selectedValue={value}
                options={VALUE_TYPES}
                label={'name'}
                onSelectChange={onChange}
                secondary={true}
              />
            </LabeledSelectBox>
          )}
        />
      </div>
    </section>
  );
};

export default LimitValueTypeSel;
